"use client";

import { useTranslations } from "next-intl";
import { useMemo } from "react";
import { css } from "styled-system/css";

import { Tabs } from "@/components/tabs";

import { FILTER_TRANSLATION_KEYS } from "../../category-keys";
import type { RewardsFilter, RewardStatus } from "../../types";

const TAB_IDS = [
  "all",
  "claimable",
  "in_progress",
  "not_eligible",
  "claimed",
  "expired",
] as const satisfies readonly RewardsFilter[];

interface RewardsTabsProps {
  value: RewardsFilter;
  onChange: (value: RewardsFilter) => void;
  counts: Record<RewardStatus, number>;
}

export function RewardsTabs({ value, onChange, counts }: RewardsTabsProps) {
  const t = useTranslations("rewards.tabs");

  const tabs = useMemo(() => {
    const total = Object.values(counts).reduce((sum, c) => sum + c, 0);
    return TAB_IDS.map((id) => {
      const count = id === "all" ? total : counts[id];
      return {
        id,
        trigger: (
          <span className={css({ display: "inline-flex", gap: "4" })}>
            {t(FILTER_TRANSLATION_KEYS[id])}
            <span>({count})</span>
          </span>
        ),
        content: null,
      };
    });
  }, [counts, t]);

  return (
    <Tabs<RewardsFilter>
      tabs={tabs}
      value={value}
      onChange={onChange}
      hideTriggers={false}
      className={css({ h: "auto!" })}
    />
  );
}
